import { useState, useEffect } from "react";
import "./styles.scss";

import FooterColorLine from "Components/FooterColorLine";


const RedirectPage = () => {
  
  const [systemInfo, setSystemInfo] = useState({
    browser: '',
    os: ''
  });

  useEffect(() => {
  const detectBrowser = () => {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Edg")) return "Edge";
    if (userAgent.includes("Chrome") && !userAgent.includes("Edg") && !userAgent.includes("OPR")) return "Chrome";
    if (userAgent.includes("Safari") && !userAgent.includes("Chrome") && !userAgent.includes("Edg")) return "Safari";
    if (userAgent.includes("Firefox")) return "Firefox";
    return "Unknown Browser";
  };

  const detectOS = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/android/.test(userAgent)) return 'Android';
    if (/iphone|ipad|ipod/.test(userAgent)) return 'iOS';
    if (/mac/.test(userAgent)) return 'iOS';
    if (/win/.test(userAgent)) return 'Android';
    if (/linux/.test(userAgent)) return 'Android';
    return 'Unknown OS';
  };

  const os = detectOS();
  const browser = detectBrowser();

  setSystemInfo({ browser, os });

  if (os === 'Android') {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.kg.kg_ultra';
  } else if (os === 'iOS') {
    window.location.href = 'https://apps.apple.com/us/app/kg-ultra/id6737878817';
  }

}, []);

  return (
    <div>
      {/* Main Content */}
      <section>
       <div className="headerLogosContainer">
        <h1>KG</h1>
       </div>
       <div className="storeLogosContainer">
          <p>You are using: {systemInfo.os}</p>
          <div className="storeImage" onClick={() => window.location.href = 'https://play.google.com/store/apps/details?id=com.kg.kg_ultra'}>
            <img src="https://kg-stage-bucket.s3.me-central-1.amazonaws.com/google_play.png" alt="Play Store" style={{ cursor: 'pointer' }} />
          </div>
          <div className="storeImage" onClick={() => window.location.href = 'https://apps.apple.com/us/app/kg-ultra/id6737878817'}>
            <img src="https://kg-stage-bucket.s3.me-central-1.amazonaws.com/app_store.png" alt="App Store" style={{ cursor: 'pointer' }} />
          </div>
       </div>
      </section>
      <div className="footerColorLine">
        <FooterColorLine />
      </div>
    </div>
  );
};

export default RedirectPage;
